<div class="payment">
  <h3 class="payment__title">
    <noda-translate [key]="bannerInfo.title" />
  </h3>
  <p class="payment__text">
    <noda-translate [key]="bannerInfo.text" />
  </p>
  <noda-button
    iconId="arrow-right"
    iconName="controls/arrow-right"
    type="gradient"
    class="payment__btn"
    [icon]="true"
    [link]="link || null"
    [paddingExtra]="true"
    [staticLinkUrl]="foreignLink || null"
    [text]="bannerInfo.buttonText"
  />
</div>
